
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deal/[id]/bid/[bidId]",
      function () {
        return require("private-next-pages/deal/[id]/bid/[bidId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deal/[id]/bid/[bidId]"])
      });
    }
  